// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23QWK","col":"styles_col__1-Ci5","actions":"styles_actions__Ek3BX","conflict":"styles_conflict__13pzz"};